import { render } from "./AppLoadingSpinner.vue?vue&type=template&id=28d33ebd&scoped=true"
const script = {}

import "./AppLoadingSpinner.vue?vue&type=style&index=0&id=28d33ebd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d33ebd"]])

export default __exports__